/**
 * @class
 * @hideconstructor
 * @todo document this
 */
var NetworkConnectivity = {};

/**
 * @type {?HTMLIFrameElement}
 * @protected
 * @todo document this
 */
NetworkConnectivity._iframeElement = undefined;

/**
 * @type {boolean}
 * @protected
 * @todo document this
 */
NetworkConnectivity._showIframe = false;

/**
 * @type {string}
 * @protected
 * @todo document this
 */
NetworkConnectivity._url = '/static/network_test.html';

/**
 *
 * @todo document this
 */
NetworkConnectivity.show = function () {
    if (this._showIframe) {
        this.hide();
    }

    this._showIframe = true;

    // create and show iframe
    var iframe = document.createElement('iframe');
    iframe.src = this._url;
    iframe.classList.add('debugging-network-connectivity');

    //TODO: move styles to CSS file
    iframe.style.zIndex = 9999;
    iframe.style.position = 'fixed';
    iframe.style.top = '1em';
    iframe.style.left = '1em';
    iframe.style.width = '32em';
    iframe.style.height = '11em';
    iframe.style.backgroundColor = 'white';
    iframe.style.border = 'none';

    document.body.appendChild(iframe);

    this._iframeElement = iframe;

    return this._showIframe;
};

/**
 *
 * @todo document this
 */
NetworkConnectivity.hide = function () {
    this._showIframe = false;

    // destroy iframe
    this._iframeElement.parentNode.removeChild(this._iframeElement);
    this._iframeElement = undefined;

    return this._showIframe;
};

/**
 *
 * @todo document this
 */
NetworkConnectivity.toggle = function () {
    if (!this._showIframe) {
        this.show();
    } else {
        this.hide();
    }

    return this._showIframe;
};

export { NetworkConnectivity };
